import type {Catalog,ModelAnswer,QuestionRecord,ReviewRecord,SourceRef} from './types'

export interface RecentAssociation {questionId:string;answerIds:string[];reason:string}
export interface AnswerCorrection {originalHash:string;answer:ModelAnswer;review:ReviewRecord}
export interface LibrarySupplement {
 version:string;generatedAt:string;baselineSha256:string
 sources:SourceRef[];answers:ModelAnswer[];reviews:ReviewRecord[];questions:QuestionRecord[]
 associations:RecentAssociation[]
 corrections?:AnswerCorrection[]
}
export type StudyLibrary = Catalog & {recentAssociations?:RecentAssociation[];originalAnswerHashes?:Record<string,string>}
export function mergeLibrary(base:Catalog,extra:LibrarySupplement):StudyLibrary {
 const append=<T extends {id:string}>(old:T[],add:T[])=>{
  const ids=new Set(old.map(x=>x.id))
  for(const item of add){if(ids.has(item.id))throw Error('Duplicate supplement ID: '+item.id);ids.add(item.id)}
  return [...old,...add]
 }
 const corrections=new Map<string,AnswerCorrection>()
 for(const c of extra.corrections??[]){
  const original=base.answers.find(a=>a.id===c.answer.id)
  if(corrections.has(c.answer.id)||!original||original.contentHash!==c.originalHash||c.answer.reviewId!==original.reviewId||c.review.id!==c.answer.reviewId||c.review.answerId!==c.answer.id||c.review.contentHash!==c.answer.contentHash)throw Error('Invalid or stale answer correction: '+c.answer.id)
  corrections.set(c.answer.id,c)
 }
 return {...base,answers:append(base.answers.map(a=>corrections.get(a.id)?.answer??a),extra.answers),sources:append(base.sources,extra.sources),questions:append(base.questions,extra.questions),reviews:append(base.reviews.map(r=>corrections.get(r.answerId)?.review??r),extra.reviews),recentAssociations:extra.associations,originalAnswerHashes:Object.fromEntries([...corrections].map(([id,c])=>[id,c.originalHash]))}
}
